import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=41d07f72&scoped=true&"
var script = {}
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=41d07f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d07f72",
  null
  
)

export default component.exports